import UltMeta, { Meta } from "./UltMeta/index";

class DisplayFormType extends UltMeta {
    /**
     * 不展示
     */
    NONE = new Meta(3, "不展示");
    /**
     * 单图固定
     */
    SINGLE = new Meta(1, "单图固定");
    /**
     * 多图轮播
     */
    MANY = new Meta(2, "多图轮播");
}
export const DISPLAY_FORM_TYPE = new DisplayFormType();

class TimeIntervalType extends UltMeta {
    /**
     * 3S
     */
    THREE = new Meta(1, "3S");
    /**
     * 5S
     */
    FIVE = new Meta(2, "5S");
}
export const TIME_INTERVAL_TYPE = new TimeIntervalType();

/**
 * 找货源广告位
 */
class AdPosition extends UltMeta {
    /**
     * banner广告位
     */
    POS_1 = new Meta(1, "banner广告位");
    /**
     * 广告位--支持上下两张、2合1 的广告位
     */
    POS_2 = new Meta(2, "广告位");
    // /**
    //  * 3号广告位
    //  */
    // POS_3 = new Meta(3, "3号广告位");
    // /**
    //  * 4号广告位
    //  */
    // POS_4 = new Meta(4, "4号广告位");
    // /**
    //  * 5号广告位
    //  */
    // POS_5 = new Meta(5, "5号广告位");
    /**
     * 寄售广告位
     */
    POS_6 = new Meta(6, "寄售广告位");
    /**
     * 团购广告位
     */
    POS_7 = new Meta(7, "团购广告位");
    /**
     * 捡漏广告位
     */
    POS_8 = new Meta(8, "捡漏广告位");
}
export const AD_POSITION = new AdPosition();

class PositionType extends UltMeta {
    /**
     * 首页广告位
     */
    HOMEPAGE_PLACEMENT = new Meta(1, "首页广告位");
    /**
     * 查砂价广告位
     */

    FIND_SAND_PRICE_PLACEMENT = new Meta(2, "查砂价广告位");
    /**
     * 查运价广告位
     */

    FIND_SHIPPING_PRICE_PLACEMENT = new Meta(3, "查运价广告位");
    /**
     * 货找船广告位
     */
    GOODS_FIND_SHIP_PLACEMENT = new Meta(4, "货找船广告位");
    /**
     * 看资讯广告位
     */
    FIND_INFORMATION_PLACEMENT = new Meta(5, "看资讯广告位");
    /**
     * 找货源广告位
     */
    FIND_GOODS_SOURCE_PLACEMENT = new Meta(6, "找货源广告位");
    /**
     * 找商机广告位
     */

    FIND_BUSINESS_OPPORTUNITY_PLACEMENT = new Meta(7, "找商机广告位");
    /**
     * 资源地图广告位
     */

    RESOURCE_MAP_PLACEMENT = new Meta(8, "资源地图广告位");
    /**
     * 找资金广告位
     */

    FIND_FUNDING_PLACEMENT = new Meta(9, "找资金广告位");
    /**
     * 首页banner广告位
     */
    HOMEPAGE_BANNER_PLACEMENT = new Meta(10, "首页banner广告位");
    /**
     * 首页最新活动广告位
     */
    HOMEPAGE_ACTIVITY_PLACEMENT = new Meta(11, "首页最新活动广告位");
}
export const POSITION_TYPE = new PositionType();

class LinkType extends UltMeta {
    /**
     * 广告页
     */
    ADVERT = new Meta(1, "广告页");
    /**
     * 链接
     */
    LINK = new Meta(2, "链接");
}
export const LINK_TYPE = new LinkType();


/**
 * 跳转类型
 */
class JumpTypePC extends UltMeta {
    ADVERT = new Meta(1, "广告页");
    LINK = new Meta(2, "链接");
    ACTIVITY = new Meta(3, "活动");
    NOT_JUMP = new Meta(4, "不跳转");
}

export const JUMP_TYPE_PC = new JumpTypePC();
